export default "__VITE_ASSET__DGUExZna__"